// src/composables/useAccountPage.ts
import { onMounted, onBeforeUnmount, getCurrentInstance, watch, WatchStopHandle } from 'vue';
import { Store } from 'vuex';
import { AppState } from '@/store';
import { Routes } from '@/router';

interface UseAccountPageOptions {
  isModal?: boolean;
}

interface UseAccountPageServices {
  router: any; // Use VueRouter if you want to be more specific
}

export default function useAccountPage(
  options: UseAccountPageOptions = {},
  appStore: Store<AppState>,
  customerService: any,
  services: UseAccountPageServices
) {
  const { isModal = false } = options;
  const instance = getCurrentInstance();

  const checkAndHandleAuth = (): void => {
    if (!customerService.isLoggedIn() || !appStore.state.customer.profile) {
      if (isModal && instance?.proxy) {
        instance.proxy.$emit('close');
      } else if (services.router) {
        services.router.push({ name: Routes.SignIn });
      }
    }
  };

  // Watch for profile changes in the store
  const unwatch: WatchStopHandle = watch(
    () => appStore.state.customer.profile,
    () => {
      checkAndHandleAuth();
    }
  );

  onMounted(() => {
    checkAndHandleAuth();
  });

  onBeforeUnmount(() => {
    unwatch();
  });

  return {
    checkAndHandleAuth
  };
}
